import { LTLLoadItem } from '@store/ltl/types';
import { LTLWeightLimit } from '@views/ltl';

// SHOULD WE GO AHEAD AND REMOVE THESE 2 FUNCTION??
const calculateAdjustedCubicFeet = (model?: LTLLoadItem) => {
  if (model === undefined) return 0;
  if (
    model.lengthInch !== null &&
    model.widthInch !== null &&
    model.heightInch !== null &&
    model.quantity != null &&
    model.weight !== null
  ) {
    return (model.lengthInch * model.widthInch * model.heightInch) / 1728;
  }
  return 0;
};

export const calculateDensity = (model?: LTLLoadItem | null) => {
  if (model?.weight == null || Number(model.weight) === 0) {
    return '0';
  }

  if (
    model.lengthInch !== null &&
    model.widthInch !== null &&
    model.heightInch !== null &&
    model.quantity != null
  ) {
    const adjustedCubicFeet = calculateAdjustedCubicFeet(model);
    const unitsAdjustment = model.uom === 'kgs' ? 2.2 : 1;
    const density =
      (Number(model.weight) * unitsAdjustment) /
      adjustedCubicFeet /
      model.quantity;
    return !isFinite(density) ? 0 : density.toFixed(4);
  }
  return '0';
};

export const getTotalWeight = (lineItems?: LTLLoadItem[]) => {
  if (lineItems === undefined) return 0;
  let total = 0;
  lineItems.forEach((item) => {
    total += Number(item.weight ?? 0);
  });
  return total;
};

export const singleWeightTooMuch = (item: LTLLoadItem) => {
  return (
    (item.quantity ?? 0) >= 1 &&
    Number(item.weight ?? 0) / (item.quantity ?? 1) > LTLWeightLimit.Single
  );
};

export const remappedCountryCode = (country: string | undefined | null) => {
  if (country === null || country === undefined || country.trim() === '')
    return '';

  const newCountry: { [key: string]: string } = {
    US: 'USA',
    USA: 'USA',
    CA: 'CAN',
    MX: 'MEX',
    Canada: 'CAN',
    Mexico: 'MEX',
  };

  return newCountry[country];
};

// Matches a leading "Pro" label: an optional qualifier (Number/Num/No) and/or
// separator (#, :, ., -). The \b guard prevents stripping "Pro" when it is glued
// directly onto an alphanumeric value (e.g. "PRODUCT123" is left untouched).
const PRO_NUMBER_PREFIX = /^\s*pro\b\s*(?:numbers?|nums?|nos?)?\s*[#:.-]*\s*/i;

// Splits on delimiters used to join multiple pro numbers into one string.
const PRO_NUMBER_DELIMITERS = /[\s/\\,;|]+/;

/**
 * Normalizes a freight PRO number for consistent storage:
 * - trims surrounding whitespace
 * - strips prefixes like "Pro #", "Pro#", "Pro Num", "Pro Number", "Pro No", "Pro:"
 * - disallows dual values by keeping only the first token when separated by
 *   slashes or other delimiters (/ \ , ; | or whitespace)
 */
export const normalizeProNumber = (raw: string | null | undefined): string => {
  if (!raw) return '';

  const [firstValue = ''] = raw
    .replace(PRO_NUMBER_PREFIX, '')
    .trim()
    .split(PRO_NUMBER_DELIMITERS);

  return firstValue;
};
